import { Modal } from "antd";
import React from "react";
import SystemIsNotReady from "routes/ErrorPage/SystemIsNotReady";

function SystemIsNotReadyModel({ close, ...modalProps }) {
  return (
    <Modal {...modalProps} maskClosable={true} onCancel={close} width="85vw">
      <SystemIsNotReady fullScreen={false} showBack={false} style={{ transform: "scale(0.85)" }} onClose={close} />
    </Modal>
  );
}

export default SystemIsNotReadyModel;
